/**
 * Mapping from data types to their corresponding file key names for tool options
 */
export const DATA_TYPE_TO_FILE_KEY_MAP: Record<string, string> = {
  contacts: "contact_file",
  accounts: "position_file",
  notes: "note_file",
  comm_pref: "comm_settings_file",
};
